import { useGate } from "@nestoca/gate-react";
import { useTenantSetting } from "@nestoca/multi-tenant";
import { ColumnDef } from "@tanstack/react-table";

import { ApplicationTableItem } from "../types";

import {
  loanDetailHiddenColumns,
  legacyHiddenColumns,
  externalBrokerHiddenColumns,
} from "./constants";

export const useColumnsByRole = (
  baseColumns: ColumnDef<ApplicationTableItem>[]
) => {
  const gate = useGate();
  const role = gate.getRole();
  const { value: isLoanDetailsEnabled } = useTenantSetting("loanDetails");

  // Remove columns by column ID
  const filterOutColumns = (
    hiddenColumnIds: readonly (keyof ApplicationTableItem)[]
  ) => {
    return baseColumns.filter((column) => {
      return column.id && !hiddenColumnIds.includes(column.id);
    });
  };

  if (role === "externalbroker") {
    return filterOutColumns(externalBrokerHiddenColumns);
  }

  // for all other roles, respect the loan details feature flag
  const hiddenColumns = isLoanDetailsEnabled
    ? loanDetailHiddenColumns
    : legacyHiddenColumns;

  return filterOutColumns(hiddenColumns);
};
